import { PageLink } from '../../_metronic/layout/core'
import {Navigation} from '../../components/Navigation'
import useMeta from '../../hook/useMeta'
import Scripts from './layouts/Scripts'

const storeFrontScriptManagerPageBreadcrumbs: PageLink[] = [
  {
    title: 'StoreFront',
    path: '/storefronts/navigations',
    isActive: false,
  },
]

const StoreFrontScriptManagerPage = () => {
  useMeta('StoreFront Script Manager')

  return (
    <Navigation
      baseUrl={'/storefront/scripts'}
      breadcrumbs={storeFrontScriptManagerPageBreadcrumbs}
      navigationData={[
        {
          key: 'scripts-manager',
          label: 'Scripts Manager',
          component: <Scripts />,
        },
      ]}
    />
  )
}

export default StoreFrontScriptManagerPage
